import React from "react";
import { Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { PageBanner } from "@/components/site/PageBanner";

export function RewardsBadge({ label = "Royal Rewards", sub = "Member" }: { label?: string; sub?: string }) {
  return (
    <div className="relative grid h-40 w-40 shrink-0 place-items-center rounded-full bg-orchid p-1 shadow-[0_0_40px_rgba(162,44,232,0.35)]" data-testid="rewards-badge">
      <div className="grid h-full w-full place-items-center rounded-full border-2 border-gold bg-plum text-center">
        <div>
          <Crown className="mx-auto text-gold" size={28} />
          <p className="mt-1 font-glam text-xl leading-tight text-mist">{label}</p>
          <p className="font-glam text-[14px] tracking-widest text-gold">{sub}</p>
        </div>
      </div>
    </div>
  );
}

export default function Rewards() {
  return (
    <>
    <PageBanner title="Royal Rewards" crumb="Royal Rewards" />
    <div className="mx-auto max-w-7xl px-5 py-20 md:px-10">
      <p className="eyebrow">Rewards</p>
      <h2 className="mt-4 font-display text-3xl md:text-4xl">Ride like royalty.</h2>
      <div className="gold-rule mt-8 w-40" />
      <div className="mt-14 grid items-start gap-14 lg:grid-cols-[1fr_1.2fr]">
        <div className="flex flex-wrap gap-6">
          <RewardsBadge label="Royal" sub="[Tier 1]" />
          <RewardsBadge label="Royal" sub="[Tier 2]" />
        </div>
        <div className="flex flex-col gap-6 text-[15px] leading-relaxed text-mist/85">
          <p>Royal Rewards is KMT's thank-you to the riders who keep coming back.</p>
          <p className="rounded-md border border-dashed border-gold/50 p-5 text-mist/75" data-testid="rewards-placeholder">
            [Placeholder: Royal Rewards program details, tiers and perks from the Brand Bible go here. Points tracking arrives in a later version.]
          </p>
          <Link to="/book" data-testid="rewards-book-btn" className="inline-flex min-h-[48px] w-fit items-center rounded-full bg-plum px-8 font-medium text-mist transition-colors duration-200 hover:bg-orchid">Book a Ride</Link>
        </div>
      </div>
    </div>
    </>
  );
}
